/**
 * Role utility functions for frontend permission checks
 */

/**
 * Check if user can edit lab data (specimens, protocols, inventory, etc.)
 */
export const canEditLabData = (user) => {
  if (!user?.role) return false;
  return ['admin', 'lab_manager', 'lab_technician'].includes(user.role);
};

/**
 * Check if user can manage users and system settings
 */
export const canManageUsers = (user) => {
  if (!user?.role) return false;
  return ['admin', 'lab_manager'].includes(user.role);
};

/**
 * Check if user has admin privileges
 */
export const isAdmin = (user) => {
  return user?.role === 'admin';
};

/**
 * Check if user can view audit logs
 */
export const canViewAudit = (user) => {
  if (!user?.role) return false;
  return ['admin', 'lab_manager'].includes(user.role);
};

/**
 * Check if user can perform data imports
 */
export const canImportData = (user) => {
  if (!user?.role) return false;
  return ['admin', 'lab_manager', 'lab_technician'].includes(user.role);
};

/**
 * Check if user can ingest analysis findings (matches the backend gate on
 * /api/analysis-findings/preview + /commit).
 */
export const canIngestAnalysis = (user) => {
  if (!user?.role) return false;
  return ['admin', 'lab_manager', 'bioinformatician'].includes(user.role);
};

/**
 * Check if user can delete an analysis run (matches the backend gate on
 * DELETE /api/analysis-findings/runs/:run_number — narrower than ingest, as
 * deletion is destructive and bioinformatics-owned).
 */
export const canDeleteAnalysisRun = (user) => {
  if (!user?.role) return false;
  return ['admin', 'bioinformatician'].includes(user.role);
};